__turbopack_context__.v({
  "hero": "styles-module-scss-module__qCaMUG__hero",
  "hero--product-1__picture": "styles-module-scss-module__qCaMUG__hero--product-1__picture",
  "hero--secondary": "styles-module-scss-module__qCaMUG__hero--secondary",
  "hero--secondary__picture": "styles-module-scss-module__qCaMUG__hero--secondary__picture",
  "hero--secondary__text": "styles-module-scss-module__qCaMUG__hero--secondary__text",
  "hero__modLayoutOnlyText": "styles-module-scss-module__qCaMUG__hero__modLayoutOnlyText",
  "hero__modLayoutOnlyText__text": "styles-module-scss-module__qCaMUG__hero__modLayoutOnlyText__text",
  "hero__picture__modImage": "styles-module-scss-module__qCaMUG__hero__picture__modImage",
  "hero__picture__modVideo": "styles-module-scss-module__qCaMUG__hero__picture__modVideo",
  "hero__text": "styles-module-scss-module__qCaMUG__hero__text",
  "hero__text_description": "styles-module-scss-module__qCaMUG__hero__text_description",
  "hero__text_description__modInvestment": "styles-module-scss-module__qCaMUG__hero__text_description__modInvestment",
  "hero__text_description__modRetirement": "styles-module-scss-module__qCaMUG__hero__text_description__modRetirement",
  "hero__text_label": "styles-module-scss-module__qCaMUG__hero__text_label",
});
